import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PartialLiquidationDTO } from '../core/models/PartialLiquidation';

@Injectable({
  providedIn: 'root'
})
export class PartialLiquidationService {
  constructor(private apiService: ApiService) {}

  processPartialLiquidation(liquidation: PartialLiquidationDTO) {
    return this.apiService.post('/api/Payment/ProcessPartialLiquidation', liquidation);
  }

  getContractInstallments(contractId: number) {
    return this.apiService.get(`/api/Installment/Contract/${contractId}`);
  }
} 